import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import cx from 'classnames';
import Dialog from 'components/Dialog.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Activity from 'entities/Activity';
import ActivityModalLink from 'payments/components/ActivityModalLink.jsx';
import React from 'react';
import ShareCopy from 'components/ShareCopy.jsx';
import ShareFacebook from 'components/ShareFacebook.jsx';
import ShareTwitter from 'components/ShareTwitter.jsx';
import UniversalComposer from 'chat/components/UniversalComposer.jsx';

export const SHARE_MODAL = 'share_modal';

import './styles/ActivityShareModal.scss';

export default React.createClass({
  propTypes: {
    activity: React.PropTypes.instanceOf(Activity).isRequired,
  },

  render() {
    const link = this.props.activity.getPayUrl();
    const title = this.props.activity.isSender() ?
      'Share this activity with your class' :
      'Share this activity';

    return (
      <Dialog
        {...this.props}
        size="small"
        imageSize="medium"
        image={require('assets/images/payments/payment-request.svg')}
        title={title}
        subtext="Anyone can participate by visiting the website below:"
        className={cx('ActivityShareModal', this.props.className)}>
        <BoxBody className="ActivityShareModal-boxBody">
          <ActivityModalLink link={link} />
          {this.props.activity.isSender() &&
            <ModalTrigger
              modal={<UniversalComposer canAnnounce activity={this.props.activity} />}>
              <Button
                className="ActivityShareModal-MessageClass"
                onClick={this.sendMessage}
                eventElementName="ActivityShareModal-MessageClass">
                Message your class
              </Button>
            </ModalTrigger>
          }
          <div className="ActivityShareModal-shares">
            <ShareTwitter text={link} />
            <ShareFacebook link={link} />
            <ShareCopy text={link} />
          </div>
        </BoxBody>
      </Dialog>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/ActivityShareModal.jsx